import Cookies from "js-cookie";

const ACCESS_TOKEN_COOKIE_NAME = "sportsmet-access-token";

export default function getAccessToken(): string | undefined {
  return Cookies.get(ACCESS_TOKEN_COOKIE_NAME);
}
